import classnames from 'classnames/bind'
import { isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import styles from './search_field.module.scss'

const cx = classnames.bind(styles)
const SearchField = ({ className, keyword, name, onChange }) => {
  const [value, setValue] = useState(keyword)
  const inputRef = useRef(null)

  const handleChange = e => {
    const newValue = trim(e.target.value)
    setValue(isEmpty(newValue) ? null : newValue)
    onChange(newValue)
  }

  useEffect(() => {
    if (isEmpty(value)) {
      inputRef.current.value = ''
    }
  })

  return (
    <div className={cx(className, styles.searchFieldContainer)}>
      <input
        ref={inputRef}
        type="search"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        name={name}
        className={styles.searchField}
        placeholder={I18n.t('components.destinations_field.search_field.placeholder')}
        defaultValue={value}
        onChange={e => handleChange(e)}
      />
    </div>
  )
}

SearchField.propTypes = {
  className: PropTypes.string,
  keyword: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

SearchField.defaultProps = {
  className: null,
  keyword: null,
  name: 'name'
}

export default SearchField
